import $ from 'jquery';
import portals from './portals';

function genQueryStr(obj) {
    const arr = [];
    for(let key in obj) {
        let v = obj[key];
        if(typeof v !== 'undefined') {
            arr.push(key + '=' + encodeURIComponent(obj[key]));
        }
    }
    return arr.join('&');
}

const dao = {
    /**
     * ajax请求
     * @param { Object } payload 页面加载所需要参数
     *     name {Object}: portal name
     *     queries: query 参数，非必填项
     *     data: post方式下的data参数，非必填项
     *     headers: 可添加headers，非必填项
     * @return promise
     */
    x: function(payload) {
        let portal = portals[payload.name];
        if(!portal) {
            throw new Error(`Portal name "${payload.name}" 不存在`);
        }
        let queryStr = genQueryStr(payload.queries);
        let uri = portal.uri || payload.uri;

        if(queryStr) {
            if(uri.lastIndexOf('?') !== -1) {
                uri += queryStr;
            }
        }

        let options = {
            url: uri,
            type: portal.method,
            headers: Object.assign({}, portal.headers),
            data: payload.data,
            dataType: portal.adapter || 'json'
        };

        if(portal.adapter === 'jsonp') {
            debugger
            Object.assign(options, {
                jsonp: 'callback',
                cache: false,
                timeout: 2000
            });
        }

        if(payload.headers) {
            options.headers = Object.assign(options.headers, payload.headers);
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                ...options,
                success: res => {
                    resolve(res)
                },
                error: err => {
                    reject(err);
                }
            });
        });
    }
};

export default dao